import { Button } from '@/components/ui/Button';
import { XStack, YStack } from '@/components/ui/layout/layout';
import { electronApis } from '@/features/electron-api';

import type { AppSetup, AppSetupStep } from './app-setup';

function AppSetupCard({
  appSetup,
  step,
}: {
  appSetup: AppSetup;
  step: AppSetupStep;
}) {
  return (
    <XStack className="items-start gap-3 rounded-lg border border-border bg-surface px-4 py-3">
      <YStack className="min-w-0 flex-1 gap-0.5">
        <span className="text-sm font-medium text-foreground">
          {step.title}
        </span>
        <span className="text-xs leading-relaxed text-foreground-muted">
          {step.detail}
        </span>
      </YStack>
      {step.trailingLabel ? (
        <span className="shrink-0 self-center text-xs text-foreground-muted">
          {step.trailingLabel}
        </span>
      ) : (
        <Button
          variant="outline"
          size="sm"
          className="shrink-0"
          onClick={() =>
            void electronApis.system.openExternal(appSetup.launchUrl)
          }
        >
          Open {appSetup.appName}
        </Button>
      )}
    </XStack>
  );
}

export function AppSetupSteps({
  appSetup,
  steps,
}: {
  appSetup: AppSetup;
  steps: readonly AppSetupStep[];
}) {
  return steps.map((step) => (
    <AppSetupCard key={step.title} appSetup={appSetup} step={step} />
  ));
}
